import { Tooltip } from "@xola/ui-kit";
import { DateFormat } from "common";
import dayjs from "dayjs";
import React from "react";
import { useSeller } from "../../hooks/useAccount";

export const CurrentTime = () => {
    const seller = useSeller();
    const now = dayjs().format("ll hh:mm A Z");
    const timeInTimezone = dayjs().tz().format("ll hh:mm A Z");
    const guessedTimezone = dayjs.tz.guess();
    const isSame = now === timeInTimezone;
    const city = seller.city.replace("United States", "USA");

    const userDate = dayjs().format(DateFormat.DATE_TIME_UTC_ISO);
    const sellerDate = dayjs().tz().format(DateFormat.DATE_TIME_UTC_ISO);
    const diff = dayjs(userDate).diff(sellerDate);
    const format = diff > 0 ? "H[h] m[m] [ahead]" : "H[h] m[m] [behind]";
    const diffString = dayjs.duration(diff).format(format);

    return (
        <div>
            <div className="table">
                <div className="table-row">
                    <div className="table-cell whitespace-nowrap">
                        <Tooltip
                            content={`Time in this user's timezone ${guessedTimezone} (from browser info)`}
                            delay={1000}
                            duration={500}
                        >
                            <span className="mr-1">{now}</span>
                        </Tooltip>
                        {!isSame && (
                            <div className="text-sm leading-p1 text-gray-dark">
                                <b>Timezone:</b> {guessedTimezone}
                                <span className="ml-1 font-semibold">{diffString}</span>
                            </div>
                        )}
                    </div>
                </div>
                {!isSame && (
                    <div className="table-row">
                        <div className="table-cell pt-1 leading-p1">
                            <Tooltip content={`Time in Seller's city of ${city}`} delay={1000} duration={500}>
                                <span>{timeInTimezone}</span>
                            </Tooltip>
                            <div className="text-sm text-gray-dark">
                                <b>Timezone:</b> {seller.timezoneName}&nbsp;
                                <b>City:</b> {city}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
